// 2013-2022的office默认主题
import { IClrScheme } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import { STSchemeColorVal } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';
import { CLASSIC_THEME } from '@src/slide/application/service/theme-color-manager/theme-config';

export const OFFICE_THEME_2013: IClrScheme = {
    [STSchemeColorVal.dk1]: '000000',
    [STSchemeColorVal.lt1]: 'FFFFFF',
    [STSchemeColorVal.dk2]: '44546A',
    [STSchemeColorVal.lt2]: 'E7E6E6',
    [STSchemeColorVal.accent1]: '4472C4',
    [STSchemeColorVal.accent2]: 'ED7D31',
    [STSchemeColorVal.accent3]: 'A5A5A5',
    [STSchemeColorVal.accent4]: 'FFC000',
    [STSchemeColorVal.accent5]: '5B9BD5',
    [STSchemeColorVal.accent6]: '70AD47',
    [STSchemeColorVal.hlink]: '0563C1',
    [STSchemeColorVal.folHlink]: '954F72',
};

// 2023的office默认主题
export const OFFICE_THEME_2023: IClrScheme = {
    [STSchemeColorVal.dk1]: '',
    [STSchemeColorVal.lt1]: '',
    [STSchemeColorVal.dk2]: '',
    [STSchemeColorVal.lt2]: '',
    [STSchemeColorVal.accent1]: '',
    [STSchemeColorVal.accent2]: '',
    [STSchemeColorVal.accent3]: '',
    [STSchemeColorVal.accent4]: '',
    [STSchemeColorVal.accent5]: '',
    [STSchemeColorVal.accent6]: '',
    [STSchemeColorVal.hlink]: '',
    [STSchemeColorVal.folHlink]: '',
};

//
export const TENCENT_DOCS_THEME: IClrScheme = {
    [STSchemeColorVal.dk1]: '',
    [STSchemeColorVal.lt1]: '',
    [STSchemeColorVal.dk2]: '',
    [STSchemeColorVal.lt2]: '',
    [STSchemeColorVal.accent1]: '',
    [STSchemeColorVal.accent2]: '',
    [STSchemeColorVal.accent3]: '',
    [STSchemeColorVal.accent4]: '',
    [STSchemeColorVal.accent5]: '',
    [STSchemeColorVal.accent6]: '',
    [STSchemeColorVal.hlink]: '',
    [STSchemeColorVal.folHlink]: '',
};


Object.keys(CLASSIC_THEME[0].colorSchema).forEach((key) => {
    const { val, color } = CLASSIC_THEME[0].colorSchema[key];
    TENCENT_DOCS_THEME[val] = color;
});

Object.keys(CLASSIC_THEME[1].colorSchema).forEach((key) => {
    const { val, color } = CLASSIC_THEME[1].colorSchema[key];
    OFFICE_THEME_2013[val] = color;
});
